import { render } from "./AppNav.vue?vue&type=template&id=8bf18dc8"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"

import "./AppNav.vue?vue&type=style&index=0&id=8bf18dc8&lang=scss"
script.render = render

export default script